import { render, staticRenderFns } from "./ViewBusinesses.vue?vue&type=template&id=c4b08f04"
import script from "./ViewBusinesses.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBusinesses.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports